var _path, _path2, _path3, _path4, _mask, _g, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__paint0_linear)",
    d: "M0 0h44v44H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.539 10.845H33v20.383c0 .893-.724 1.617-1.618 1.617H12.27l1.27-1.32v-20.68z",
    fill: "#F3F4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.158 25.23h-6.37v.91h6.37v-.91zm-7.377 0h-6.37v.91h6.37v-.91zm-6.369 1.82h6.37v.91h-6.37v-.91zm13.746 0h-6.37v.91h6.37v-.91zm-13.746 1.82h6.37v.91h-6.37v-.91zm13.746 0h-6.37v.91h6.37v-.91z",
    fill: "#719FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__paint1_linear)",
    d: "M16.411 14.696h13.746v8.591H16.411z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "news_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 14,
    width: 15,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.411 14.696h13.746v8.591H16.411z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#news_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.23 19.307a1.692 1.692 0 100-3.385 1.692 1.692 0 000 3.385z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.308 23.537v-3.38c-3.446-.047-7.519.362-11.847 3.38h11.847z",
    fill: "#0045D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.263 20.625c-3.739-1.858-6.213-1.445-8.186-.62v3.533h15.23v-1.64c-2.174.055-4.835-.177-7.044-1.273z",
    fill: "#195DEE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.27 32.845c1.015 0 1.269-.846 1.269-1.27V13.384H11v18.193c0 .423.254 1.269 1.27 1.269z",
    fill: "#A8C4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 42.99C10.407 42.99 1.01 33.593 1.01 22h-2.02c0 12.708 10.302 23.01 23.01 23.01v-2.02zM42.99 22c0 11.593-9.397 20.99-20.99 20.99v2.02c12.708 0 23.01-10.302 23.01-23.01h-2.02zM22 1.01c11.593 0 20.99 9.397 20.99 20.99h2.02C45.01 9.292 34.708-1.01 22-1.01v2.02zm0-2.02C9.292-1.01-1.01 9.292-1.01 22h2.02C1.01 10.407 10.407 1.01 22 1.01v-2.02z",
    fill: "#EEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__paint0_linear",
    x1: 1.312,
    y1: 1.877,
    x2: 47.068,
    y2: 37.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195DEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__paint1_linear",
    x1: 23.284,
    y1: 23.288,
    x2: 23.284,
    y2: 14.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B9FF"
  })))));
}
export default SvgNews;